import type { Assessment } from "@thalamos/haven-common";

// TODO(assessments): show the service's own reference once assessments carry one.
/**
 * What an assessment is called on screen: the start of its id, which is short
 * enough to read out and stays the same however often it is shown.
 */
export const assessmentReference = (assessment: Pick<Assessment, "id">) =>
  assessment.id.slice(0, 8).toUpperCase();
